import React from "react"
import { QueryClient, QueryClientProvider } from "react-query"

import { IsoLocale } from "@izettle/constants"
import { TranslationsProvider } from "@izettle/tenko-react"

export const AppProvider: React.FC<{
  allowedLocales?: IsoLocale[]
  defaultLocale?: IsoLocale
}> = ({ children, allowedLocales, defaultLocale }) => {
  const queryClient = new QueryClient()

  return (
    <TranslationsProvider allowedLocales={allowedLocales} defaultLocale={defaultLocale}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </TranslationsProvider>
  )
}
